import script from "./NoteCreatorsStack.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteCreatorsStack.vue?vue&type=script&setup=true&lang=js"

import "./NoteCreatorsStack.vue?vue&type=style&index=0&id=19b33f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b33f60"]])

export default __exports__